export function formatPrice(amount) {
  if (amount == null) return '';
  return `₡${amount.toLocaleString('es-CR')}`;
}
